var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#232323",
  fillRule: "evenodd",
  d: "M8 2a.75.75 0 0 1 .75.75V4h6.5V2.75a.75.75 0 0 1 1.5 0V4H18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.25V2.75A.75.75 0 0 1 8 2m-.75 3.5H6A1.5 1.5 0 0 0 4.5 7v1.5h15V7A1.5 1.5 0 0 0 18 5.5h-1.25v.75a.75.75 0 0 1-1.5 0V5.5h-6.5v.75a.75.75 0 0 1-1.5 0zM19.5 10h-15v9A1.5 1.5 0 0 0 6 20.5h12a1.5 1.5 0 0 0 1.5-1.5z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 13,
  r: 1,
  fill: "#232323"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 13,
  r: 1,
  fill: "#232323"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 13,
  r: 1,
  fill: "#232323"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 17,
  r: 1,
  fill: "#232323"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 17,
  r: 1,
  fill: "#232323"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 17,
  r: 1,
  fill: "#232323"
})));
export default SvgCalendar;